import React from 'react';
import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';
import ObjectListInlineWidget from '@eeacms/volto-object-widget/Widget/ObjectListInlineWidget';
import { defineMessages } from 'react-intl';


const messages = defineMessages({
  social_networks: {
    id: 'Social networks',
    defaultMessage: 'Social networks',
  },
  social_network: {
    id: 'Social network',
    defaultMessage: 'Social network',
  },
  link: {
    id: 'Link',
    defaultMessage: 'Link',
  },
  term: {
    id: 'Item',
    defaultMessage: 'Item',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  category: {
    id: 'Category',
    defaultMessage: 'Category',
  },
  element: {
    id: 'Element',
    defaultMessage: 'Element',
  },
});

const SocialNetworkSchema = (props) => {
    return {
        title: props.intl.formatMessage(messages.social_networks),
        properties: {
            social_network: {
                title: props.intl.formatMessage(messages.social_network),
                widget: 'select',
                choices: [
                  ['facebook', 'Facebook'],
                  ['twitter', 'X'],
                  ['instagram', 'Instagram'],
                  ['youtube', 'YouTube'],
                  ['linkedin', 'LinkedIn'],
                ],
            },
            link: {
                title: props.intl.formatMessage(messages.link),
            },
        },
        fieldsets: [
            {
                id: 'default',
                title: props.intl.formatMessage(messages.social_network),
                fields: [
                    'social_network',
                    'link',
                ],
            },
        ],
        required: ['social_network', 'link'],
    };
};


const TramitsSchema = (props) => {
    return {
        title: props.intl.formatMessage(messages.term),
        properties: {
            title: {
                title: props.intl.formatMessage(messages.title),
            },
            link: {
                title: props.intl.formatMessage(messages.link),
            },
            category: {
                title: props.intl.formatMessage(messages.category),
            },
        },
        fieldsets: [
            {
                id: 'default',
                title: props.intl.formatMessage(messages.term),
                fields: [
                    'title',
                    'link',
                    'category',
                ],
            },
        ],
        required: ['title', 'link', 'category'],
    };
};


const ItemSchema = (props) => {
    return {
        title: props.intl.formatMessage(messages.term),
        properties: {
            term_id: {
                title: 'ID',
            },
            title: {
                title: props.intl.formatMessage(messages.title),
            },
        },
        fieldsets: [
            {
                id: 'default',
                title: props.intl.formatMessage(messages.term),
                fields: [
                    'term_id',
                    'title',
                ],
            },
        ],
        required: ['term_id', 'title'],
    };
};


const DefaultElementSchema = (props) => {
    return {
        title: props.intl.formatMessage(messages.element),
        properties: {
            title: {
                title: props.intl.formatMessage(messages.title),
            },
        },
        fieldsets: [
            {
                id: 'default',
                title: props.intl.formatMessage(messages.title),
                fields: [
                    'title',
                ],
            },
        ],
        required: ['title'],
    };
};


const LinesWidget = (props) => {
    const schemas = {
        equipment_types: ItemSchema,
        entity_scopes: ItemSchema,
        social_networks: SocialNetworkSchema,
        tramits: TramitsSchema,
    };

    const schemaFunc = schemas?.[props?.id] || DefaultElementSchema;
    const activeSchema = schemaFunc(props);
    const safeValue = props.value?.items || props.default?.items || [];
    const WidgetComponent = props?.id === 'social_networks' 
        ? ObjectListWidget 
        : ObjectListInlineWidget;

    return (
        <WidgetComponent
            {...props}
            schema={activeSchema}
            value={safeValue}
            onChange={(id, value) => {
                props.onChange(id, { items: value });
            }}
        />
    );
};

export default LinesWidget;